<template>
    <el-container>
        <el-header>
            <span>Tax Info</span>
        </el-header>

        <el-main>
            <div>
                <!----------------------------------页面内容---------------------------------->
                <el-row>
                    <el-form label-position="left" label-width="160px" ref="form" v-loading="loading" class="taxListform">

                        <el-card class="withholding-tax-card">
                            <el-row>
                                <el-col :span="16" class="biaoti">
                                    <div class="grid-content bg-purple">
                                        <span>{{userSetting.withHoldingTaxName}}</span>
                                    </div>
                                </el-col>
                            </el-row>
                            <el-divider></el-divider>

                            <el-form-item :label="userSetting.withHoldingTaxName+'('+userSetting.withHoldingTaxRate+'%)'">
                                <el-switch v-model="userSetting.withHoldingActive" :active-value=1 :inactive-value=0></el-switch>
                            </el-form-item>

                            <el-form-item label="Rate(%)">
                                <el-input onfocus="this.select()" @blur="formatWithHoldingBlur(userSetting.withHoldingTaxRate)" @keyup.native="formatNow1" v-model="userSetting.withHoldingTaxRate"></el-input>
                            </el-form-item>

                            <el-form-item label="Abbreviation">
                                <el-input type="text" v-model="userSetting.withHoldingTaxName"></el-input>
                            </el-form-item>

                            <el-button style="margin-left: 1%" @click.native.prevent="updateWithholding" type="success">Save</el-button>
                        </el-card>


                        <el-card class="taxes-card">
                            <el-row>
                                <el-col :span="16" class="biaoti">
                                    <div class="grid-content bg-purple">
                                        <span>Taxes</span>
                                    </div>
                                </el-col>
                            </el-row>
                            <el-divider></el-divider>

                            <el-form-item class="taxItemList" :label='taxInfo.taxName' v-for="taxInfo in userTaxInfoList" :key="taxInfo.innerUUID">
                                <el-button class="taxListButton" v-model="taxInfo.rates" @click="openDialog(taxInfo)">
                                    {{taxInfo.firstRate}}
                                </el-button>
                                <el-button style="margin-left: 3%;color: red" type="text" @click="prepareDeleteTax(taxInfo.innerUUID)">Delete</el-button>
                            </el-form-item>
                                <el-form-item label=''>
                                    <el-button type="text" @click="addTax()">Add tax</el-button>
                                </el-form-item>
                        </el-card>

                        <el-card class="tax-year-start-card">
                            <el-row>
                                <el-col :span="16" class="biaoti">
                                    <div class="grid-content bg-purple">
                                        <span>Tax year starts</span>
                                    </div>
                                </el-col>
                            </el-row>
                            <el-divider></el-divider>
                            <div class="tax-year-subtitle">Set the first day of the financial year</div>
                            <div class="tax-year-controls">
                                <el-form-item label="Month">
                                    <el-select v-model="taxYearStartMonth" placeholder="Month" @change="changeTaxYearStartMonth">
                                        <el-option
                                                v-for="month in monthOptions"
                                                :key="month.value"
                                                :label="month.label"
                                                :value="month.value"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="Day">
                                    <el-select v-model="taxYearStartDay" placeholder="Day">
                                        <el-option
                                                v-for="day in dayOptions"
                                                :key="day.value"
                                                :label="day.label"
                                                :value="day.value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <el-button style="margin-left: 1%" @click.native.prevent="updateTaxYearStart" type="success">Save</el-button>
                        </el-card>
                    </el-form>
                </el-row>
                <!----------------------------------页面内容---------------------------------->


                <el-dialog
                        title="Delete"
                        :visible.sync="deleteTaxDialog"
                        width="30%">
                    <span>Are you sure delete this tax?</span>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="deleteTaxDialog = false">Cancel</el-button>
                        <el-button type="primary" @click="deleteTax()">Delete</el-button>
                      </span>
                </el-dialog>

                <!----------------------------------弹出框,增加或者修改税信息---------------------------------->
                <el-dialog title="Tax Info" :visible.sync="dialogOpen" width="40%">
                    <el-form label-width="200px">
                        <!--税信息-->
                        <el-form-item label="Tax Name">
                            <el-input v-model="taxInfoName"></el-input>
                        </el-form-item>
                        <el-form-item label="Standard rate (%)">
                            <el-input onfocus="this.select()" @keyup.native="formatNow1" v-model="standardRate"></el-input>
                        </el-form-item>
                        <el-form-item class="tax_delete" :label="'Additional rate '+ (index+1)+'(%)'"
                                      v-for="(value,index) in userTaxItemList " :key="index">
                            <el-input style="display: inline" onfocus="this.select()" @keyup.native="formatNow1" v-model="userTaxItemList[index]"></el-input>
                            <el-button style="margin-left: 5%;color: red" @click="deleteRate(index)" type="text">X
                            </el-button>
                        </el-form-item>
                        <el-form-item label="">
                            <el-button type="text" @click="addRate()">Add rate</el-button>
                        </el-form-item>


                        <el-form-item label="Tax type">
                            <el-radio-group v-model="taxInclusive" size="middle">
                                <el-radio-button :disabled="exclusiveStatus" label="0">Exclusive</el-radio-button>
                                <el-radio-button :disabled="inclusiveStatus" label="1">Inclusive</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>
                    <!--弹框的底部标签-->
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogOpen = false">close</el-button>
                        <el-button type="primary" @click="saveTaxInfo()" v-loading="dialogSaveLoading">Save tax
                        </el-button>
                    </div>
                </el-dialog>

                <!----------------------------------弹出框,增加或者修改税信息---------------------------------->
                <el-dialog :visible.sync="cantOpenDetail" width="40%"
                           :close-on-click-modal="false"
                           :close-on-press-escape="false"
                           :show-close="false">
                    <div style="font-size: 20px;line-height: 2;">
                        This tax contains cumulative tax. Web does not support this function temporarily
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <el-button type="primary" @click="cantOpenDetail = false">Close</el-button>
                    </div>
                </el-dialog>
            </div>
        </el-main>

    </el-container>
</template>

<script>
    import {uuid, timest} from '@/utils/validate'
    import {formatNow, formatAtCreate} from '@/utils/numberFormat'
    import {syncCompanySelection} from '@/utils/company'

    export default {
        methods: {
            formatNow1: formatNow,

            //打开对话框
            openDialog(taxInfo) {

                if (taxInfo.accumulateTaxInfoUUIDArrayKey != '' || taxInfo.beAccumulateTaxInfoUUIDArrayKey != '') {
                    this.cantOpenDetail = true;
                    return;
                }
                this.taxInfoName = taxInfo.taxName;
                this.taxId = taxInfo.taxId;
                this.innerUUID = taxInfo.innerUUID;
                var taxSplit = taxInfo.rates.split("&&");
                this.standardRate = parseFloat((taxSplit[0] * 100).toFixed(4));
                this.taxInclusive = taxInfo.taxInclusive;
                taxSplit.splice(0, 1);
                this.userTaxItemList = taxSplit;
                for (var i = 0; i < this.userTaxItemList.length; i++) {
                    this.userTaxItemList[i] = parseFloat((this.userTaxItemList[i] * 100).toFixed(4))
                }
                this.createOrUpdate = 2;
                this.dialogOpen = true
            },
            //增加rate
            addRate() {
                this.userTaxItemList.push("")
            },
            //增加Tax
            addTax() {
                this.taxInfoName = "";
                this.taxInclusive = 0;
                this.standardRate = "";
                this.userTaxItemList = [];
                this.createOrUpdate = 1;
                this.dialogOpen = true
            },
            //删除rate
            deleteRate(index) {
                this.userTaxItemList.splice(index, 1);
            },
            formatWithHoldingBlur(number) {
                this.userSetting.withHoldingTaxRate = formatAtCreate(number);
            },
            formatTaxRateDisplay(rates) {
                let taxSplit = rates.split("&&");
                let visibleRateList = taxSplit.slice(0, 3).map(rate => {
                    return parseFloat((rate * 100).toFixed(4)) + "%";
                });
                let hiddenRateCount = taxSplit.length - visibleRateList.length;
                if (hiddenRateCount > 0) {
                    visibleRateList.push(hiddenRateCount + (hiddenRateCount === 1 ? " more rate" : " more rates"));
                }
                return visibleRateList.join(", ");
            },

            //删除tax
            async deleteTax() {
                let me = this;
                this.$axios.post('update_tax_info', {
                    params: {
                        accessDate: timest(),
                        innerUUID: me.prepareDeleteTaxUUID,
                        syncStatus: 1
                    }
                }).then(response => {
                    self.dialogSaveLoading = false;
                    if (response.data.errorCode == 0) {
                        this.deleteTaxDialog = false;
                        //如果有关联复税，还需要更新对应的 beAccumulateTaxInfoUUIDArrayKey 字段
                    }
                    this.queryUserTaxInfoList();
                }).catch(() => {
                    this.deleteTaxDialog = false;
                    this.queryUserTaxInfoList();
                })
            },

            //准备删除删除tax
            prepareDeleteTax(innerUUID) {
                this.deleteTaxDialog = true;
                this.prepareDeleteTaxUUID = innerUUID;
            },

            ///////////////////////保存/update开始///////////////////////
            async saveTaxInfo() {
                //保存
                this.standardRate = formatAtCreate(this.standardRate);
                if (this.standardRate === '' || this.standardRate === "0") {
                    this.$message.error('rate is must');
                    return;
                }
                //标准税
                let rateString = parseFloat((formatAtCreate(this.standardRate) / 100).toFixed(6)) + "&&";

                //用于判断是否有相同的税
                let haveRateArray = [];

                for (let i = 0; i < this.userTaxItemList.length; i++) {
                    let everyTaxRate = formatAtCreate(this.userTaxItemList[i]);
                    if (everyTaxRate === '' || everyTaxRate === "0") {
                        this.$message.error('rate is must');
                        return;
                    }
                    //需要判断是否有重复的税
                    if (everyTaxRate == this.standardRate) {
                        continue;
                    }
                    let haveRate = false;
                    for (let j = 0; j < haveRateArray.length; j++) {
                        if (haveRateArray[j] === everyTaxRate) {
                            haveRate = true;
                            break;
                        }
                    }
                    if (haveRate) {
                        continue;
                    }
                    haveRateArray.push(everyTaxRate);

                    rateString = rateString + parseFloat((everyTaxRate / 100).toFixed(6)) + "&&"
                }
                rateString = rateString.substring(0, rateString.length - 2);

                //关闭dialog框
                this.dialogSaveLoading = true;
                let self = this;

                if (this.createOrUpdate === 1) {
                    let createUUID = uuid(null, 37);
                    //新增,需要创建uuid
                    this.$axios.post('create_tax_info', {
                        params: {
                            belongToSetting: 1,
                            innerUUID: createUUID,
                            createDate: timest(),
                            accessDate: timest(),
                            rates: rateString,
                            syncStatus: 0,
                            taxInclusive: this.taxInclusive,
                            taxName: this.taxInfoName,
                            settingTaxInfoUUID: "",
                            settingUUID: self.userSetting.innerUUID,
                            accumulateTaxInfoUUIDArrayKey: "",
                            beAccumulateTaxInfoUUIDArrayKey: "",
                            webSettingTaxInfoUUID: createUUID + "," + self.userSetting.taxInfoUUIDArrayKey,
                            userSettingInnerUUID: self.userSetting.innerUUID
                        }
                    }).then(response => {
                        self.dialogSaveLoading = false;
                        if (response.data.errorCode === 0) {
                            self.dialogOpen = false;
                            this.queryUserTaxInfoList();
                            //如果有关联复税，还需要更新对应的 beAccumulateTaxInfoUUIDArrayKey 字段
                        }
                    }).catch(function () {
                        self.dialogSaveLoading = false;
                    })

                } else if (this.createOrUpdate === 2) {
                    this.$axios.post('update_tax_info', {
                        params: {
                            accessDate: timest(),
                            innerUUID: this.innerUUID,
                            rates: rateString,
                            syncStatus: 0,
                            taxInclusive: this.taxInclusive,
                            taxName: this.taxInfoName
                        }
                    }).then(response => {
                        self.dialogSaveLoading = false;
                        if (response.data.errorCode === 0) {
                            self.dialogOpen = false;
                            //如果有关联复税，还需要更新对应的 beAccumulateTaxInfoUUIDArrayKey 字段
                            this.queryUserTaxInfoList();

                        }
                    }).catch(function () {
                        self.dialogSaveLoading = false;
                    })
                }
            },
            ///////////////////////保存结束///////////////////////
            updateWithholding() {
                this.userSetting.withHoldingTaxRate = formatAtCreate(this.userSetting.withHoldingTaxRate);
                if (this.userSetting.withHoldingTaxRate === "" || this.userSetting.withHoldingTaxRate === "0") {
                    this.$message.error('Rate is a must');
                    return;
                }
                let self = this;
                this.loading = true;
                this.$axios.post('update_setting', {
                    params: {
                        innerUUID: this.userSetting.innerUUID,
                        accessDate: timest(),
                        withHoldingActive: self.userSetting.withHoldingActive,
                        withHoldingTaxName: self.userSetting.withHoldingTaxName,
                        withHoldingTaxRate: formatAtCreate(self.userSetting.withHoldingTaxRate) / 100
                    }
                }).then(response => {
                    if (response.data.errorCode == 0) {

                        this.$message.success({
                            message: 'save success',
                            center: true
                        });

                        let tempUserSetting = JSON.parse(localStorage.getItem('userSetting'));
                        tempUserSetting.withHoldingActive = this.userSetting.withHoldingActive;
                        tempUserSetting.withHoldingTaxName = this.userSetting.withHoldingTaxName;
                        tempUserSetting.withHoldingTaxRate = formatAtCreate(self.userSetting.withHoldingTaxRate) / 100;
                        localStorage.setItem('userSetting', JSON.stringify(tempUserSetting));


                        this.loading = false;
                    } else {
                        this.$message.success({
                            message: 'save failed',
                            center: true
                        });
                        this.loading = false;
                    }

                }).catch(() => {
                    this.$message.error('system error');
                    this.loading = false;
                })
            },
            setTaxYearStartFromSetting(taxYearStart) {
                if (taxYearStart == null || taxYearStart === "") {
                    return;
                }
                let taxYearStartDate = new Date(parseInt(taxYearStart, 10) * 1000);
                let month = taxYearStartDate.getMonth() + 1;
                let day = taxYearStartDate.getDate();
                this.taxYearStartMonth = month < 10 ? "0" + month : "" + month;
                this.taxYearStartDay = day < 10 ? "0" + day : "" + day;
            },
            changeTaxYearStartMonth() {
                let dayCount = new Date(1991, parseInt(this.taxYearStartMonth, 10), 0).getDate();
                if (parseInt(this.taxYearStartDay, 10) > dayCount) {
                    this.taxYearStartDay = "";
                }
            },
            updateTaxYearStart() {
                if (this.taxYearStartMonth === "" || this.taxYearStartDay === "") {
                    this.$message.error('Month and day are required');
                    return;
                }
                let taxYearStart = Math.floor(new Date(1991, parseInt(this.taxYearStartMonth, 10) - 1, parseInt(this.taxYearStartDay, 10), 0, 0, 0).getTime() / 1000);
                this.loading = true;
                this.$axios.post('update_setting', {
                    params: {
                        innerUUID: this.userSetting.innerUUID,
                        accessDate: timest(),
                        taxYearStart: taxYearStart
                    }
                }).then(response => {
                    if (response.data.errorCode === 0) {
                        this.userSetting.taxYearStart = taxYearStart;
                        let tempUserSetting = JSON.parse(localStorage.getItem('userSetting'));
                        tempUserSetting.taxYearStart = taxYearStart;
                        localStorage.setItem('userSetting', JSON.stringify(tempUserSetting));
                        this.$message.success({
                            message: 'save success',
                            center: true
                        });
                    } else {
                        this.$message.error('save failed');
                    }
                    this.loading = false;
                }).catch(() => {
                    this.$message.error('system error');
                    this.loading = false;
                })
            },

            //查询taxInfo列表
            queryUserTaxInfoList() {
                this.userTaxInfoList = [];
                this.loading = true;
                let that = this;
                this.$axios.post('query_tax_info_list_user_web', {
                    params: {
                        "currentPage": that.currentPage,
                        "pageSize": that.pageSize,
                        "delStatus": 0,
                        "invoiceTaxOrNot": 1
                    }
                }).then(response => {
                    if (response.data.errorCode == 0) {
                        var responseRateList = response.data.dataList;
                        for (let i = 0; i < responseRateList.length; i++) {
                            var rateItem = responseRateList[i];
                            rateItem.firstRate = this.formatTaxRateDisplay(rateItem.rates);
                            that.userTaxInfoList.push(rateItem);
                        }
                    }
                    this.loading = false;
                })
            },
            queryUserSetting() {
                this.loading = true;
                let that = this;
                this.$axios.post('query_setting_and_company', {
                    params: {}
                }).then(response => {
                    if (response.data.errorCode == 0) {
                        let selectedData = syncCompanySelection(response.data);
                        if (selectedData == null) {
                            this.loading = false;
                            return;
                        }
                        that.userSetting = selectedData.setting;
                        that.userSetting.withHoldingTaxRate = parseFloat((that.userSetting.withHoldingTaxRate * 100.0).toFixed(6))
                        this.setTaxYearStartFromSetting(that.userSetting.taxYearStart);
                    }
                    this.loading = false;
                })
            }
        },
        computed: {
            monthOptions() {
                let monthList = [];
                for (let i = 1; i <= 12; i++) {
                    let month = i < 10 ? "0" + i : "" + i;
                    monthList.push({
                        label: month,
                        value: month
                    });
                }
                return monthList;
            },
            dayOptions() {
                let dayList = [];
                let dayCount = new Date(1991, parseInt(this.taxYearStartMonth, 10), 0).getDate();
                for (let i = 1; i <= dayCount; i++) {
                    let day = i < 10 ? "0" + i : "" + i;
                    dayList.push({
                        label: day,
                        value: day
                    });
                }
                return dayList;
            }
        },
        data() {
            return {
                dialogOpen: false,
                userTaxInfoList: [],
                userTaxItemList: [],
                checked: true,
                taxInfoName: "",
                standardRate: 0,
                taxId: 0,
                innerUUID: "",
                taxInclusive: 0,
                account: 0,
                //1.create,2.update
                createOrUpdate: 1,
                loading: true,
                dialogSaveLoading: false,
                inclusiveStatus: false,
                exclusiveStatus: false,
                currentPage: 1,
                totalCount: 0,
                pageSize: 50,
                withholdingStatus: false,
                userSetting: {},
                deleteTaxDialog: false,
                prepareDeleteTaxUUID: "",
                cantOpenDetail: false,
                taxYearStartMonth: "",
                taxYearStartDay: ""
            }
        },
        mounted() {
            this.queryUserTaxInfoList();
            this.queryUserSetting();
        }
    }
</script>
<style scoped>
    /deep/ .el-header {
        background-color: #f7f7f9;
        font-size: 25px;
        font-weight: 700;
        height: 100px !important;
        display: flex;
        justify-content: space-between;
        padding: 30px;
    }

    /deep/ .el-input__inner {
        width: 60%;
        margin-left: 2%;
        border-style: none none solid none;
        background-color: #ffffff;
        border-radius: 0px;
    }

    .taxListButton {
        border-style: none none solid none;
        background-color: white;
        border-radius: 0px;
        width: 51%;
        text-align: left;
        white-space: nowrap;
    }

    .taxItemList {
        margin-bottom: 10px;
    }

    .taxListform {
        margin-top: 20px;
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 20px;
        align-items: start;
    }

    .taxes-card {
        grid-column: 1;
        grid-row: 1;
    }

    .tax-year-start-card {
        grid-column: 2;
        grid-row: 1;
    }

    .withholding-tax-card {
        grid-column: 1;
        grid-row: 2;
    }

    /deep/ .biaoti {
        font-size: 24px;
        padding-left: 1%;
    }

    /deep/ .margin_top_card {
        margin-top: 0;
    }

    /deep/ .el-switch {
        margin-left: 2%;
    }

    .taxListform >>> .el-form-item__label {
        position: relative;
        left: 1%;
        text-align: left;
    }

    .tax-year-subtitle {
        margin: 0 0 18px 1%;
        color: #606266;
        font-size: 15px;
    }

    .tax-year-controls {
        display: grid;
        grid-template-columns: minmax(0, 210px) minmax(0, 210px);
        column-gap: 72px;
        width: auto;
        margin-left: 1%;
    }

    .tax-year-controls >>> .el-form-item {
        display: flex;
        align-items: center;
        margin-bottom: 18px;
    }

    .tax-year-controls >>> .el-form-item__label {
        width: auto !important;
        min-width: 58px;
        padding-right: 12px;
        left: 0;
    }

    .tax-year-controls >>> .el-form-item__content {
        flex: 1;
        margin-left: 0 !important;
    }

    .tax-year-controls >>> .el-select,
    .tax-year-controls >>> .el-input {
        width: 100%;
    }

    .tax-year-controls >>> .el-input__inner {
        width: 100%;
        margin-left: 0;
    }
</style>

<style>
    .el-button--success {
        background-color: #0D7DF7;
        border-color: #0D7DF7;
    }

    .el-button--success:focus, .el-button--success:hover {
        background-color: #0D7DF7;
        border-color: #0D7DF7;
    }
</style>
